import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { immediateToast } from "izitoast-react";

import { Spinner } from "../../Components/Spinner/Spinner";

import style from "./CustomWorkout.module.css";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { callAPI } from "../../assets/Js/backendCommunication";

import workoutApiCalled from "../../redux/actionCreators/workoutApiCalled";
import shouldDuplicate from "../../redux/actionCreators/shouldDuplicate";

import projectSettings from "../../assets/Js/projectSettings";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { Date_Error, Validation_Error } from "../../assets/Js/errorMessage";

import { closeModel } from "../../assets/Js/closeModel";

const mapDispatchToProps = (dispatch) => {
  return {
    workoutApiCalled: () => dispatch(workoutApiCalled()),
    shouldDuplicate: () => {
      return dispatch(shouldDuplicate(false));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    trackInfo: state.trackInfo,
    workoutApiCalled: state.workoutApiCalled,
    isDupilicate: state.isDupilicate,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class CustomWorkout extends Component {
    constructor(props) {
      super(props);
      this.nameRef = createRef();
      this.linkRef = createRef();
      this.descriptionRef = createRef();
      this.notesRef = createRef();
      this.setsRef = createRef();
      this.scoreTypeRef = createRef();

      this.state = {
        showError: false,
        isLoading: false,
        scoreTypeList: [
          "For Completion",
          "Reps",
          "Round Reps",
          "Time",
          "Weight",
          "Text",
          "Calories",
          "Meters",
        ],
        duplicateTrackId: null,
        data: {
          id:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Id
              : null,

          name:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Name
              : "",

          link:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.videoUrl
              : "",

          description:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Description
              : "",

          notes:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Notes
              : "",

          sets:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Sets
              : "1",

          scoreType:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.ScoreType
              : 0,

          addToDatabase:
            this.props &&
            this.props.editableWorkout &&
            this.props.editableWorkout.WorkoutType.toLowerCase() === "database"
              ? true
              : false,

          addTotalToggle:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.AddTotal
              : false,
        },
      };
    }

    componentDidMount() {
      let newFromDate = new Date(this.props.workoutDate);
      newFromDate = newFromDate.toUTCString();
      this.setState({
        duplicateTrackId: this.props.duplicateTrackId,
      });
    }

    componentDidUpdate = (prevProps) => {
      if (prevProps.duplicateTrackId !== this.props.duplicateTrackId) {
        this.setState({ duplicateTrackId: this.props.duplicateTrackId });
      }
    };

    addTotalBtnChanger = () => {
      this.setState({
        data: {
          ...this.state.data,
          addTotalToggle: !this.state.data.addTotalToggle,
        },
      });
    };

    addToDatabaseBtnChanger = () => {
      this.setState({
        data: {
          ...this.state.data,
          addToDatabase: !this.state.data.addToDatabase,
        },
      });
    };

    submitHandler = (e) => {
      e.preventDefault();
      if (this.state.data.sets && this.state.data.scoreType !== null) {
        if (this.props.workoutDate !== "mm/dd/yyyy") {
          if (this.props.editableWorkout) {
            this.updateWorkout();
          } else {
            this.addWorkout();
          }
        } else {
          immediateToast("warning", {
            message: Date_Error,
          });
        }
      } else {
        immediateToast("warning", {
          message: Validation_Error,
        });
      }
    };

    updateWorkout = async () => {
      let url = this.props.isDupilicate
        ? `${projectSettings.baseUrl}/workouts/create`
        : `${projectSettings.baseUrl}/workouts/update/${this.props.trackWorkoutId}`;
      let header = true;
      let type = "POST";
      let token = getPlainToken();

      let newFromDate = new Date(this.props.workoutDate);
      newFromDate = new Date(
        newFromDate.valueOf() - newFromDate.getTimezoneOffset() * 60000
      );

      let data = {
        Name: this.state.data.name,
        Description: this.state.data.description,
        Notes: this.state.data.notes,
        ScoreType: this.state.data.scoreType,
        videoUrl: this.state.data.link,
        WorkoutType: this.state.data.addToDatabase ? "database" : "custom",
        Schedule: newFromDate,
        Sets: this.state.data.sets,
        addTotal: this.state.data.addTotalToggle,
      };
      if (this.props.isDupilicate) {
        data.TrackId = this.state.duplicateTrackId;
      }

      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, JSON.stringify(data), token);

      if (response) {
        this.props.isDupilicate
          ? apiResponseToast(
              response.status,
              "duplicateWorkout",
              response.data.message
            )
          : apiResponseToast(
              response.status,
              "editWorkout",
              response.data.message
            );

        this.setState({ isLoading: false });
        if (response.status === 403) {
        } else if (response.type === "error") {
          this.props.shouldDuplicate();
        } else if (response.type === "success") {
          closeModel(this.props.modalId);

          this.props.workoutApiCalled();
          this.props.shouldDuplicate();
          this.props &&
            this.props.resetOnCloseModal &&
            this.props.resetOnCloseModal();

          response = "";
        }
      }
    };

    addWorkout = async () => {
      let url = `${projectSettings.baseUrl}/workouts/create`;
      let header = true;
      let data = null;
      let type = "POST";
      let token = getPlainToken();

      let trackInfo = this.props ? this.props.trackInfo : null;

      let newFromDate = new Date(this.props.workoutDate);
      newFromDate = new Date(
        newFromDate.getTime() - newFromDate.getTimezoneOffset() * 60000
      );

      if (trackInfo.Id) {
        let sets = parseInt(this.state.data.sets);
        data = {
          Name: this.state.data.name,
          Description: this.state.data.description,
          Notes: this.state.data.notes,
          Sets: sets,
          ScoreType: this.state.data.scoreType,
          VideoUrl: this.state.data.link,
          Schedule: newFromDate,
          WorkoutType: this.state.data.addToDatabase ? "database" : "custom",
          TrackId: trackInfo.Id,
          benchmarkValues: [],
          addTotal: this.state.data.addTotalToggle,
        };

        let response = "";

        if (response === "") {
          this.setState({ isLoading: true });
        }

        response = await callAPI(
          url,
          header,
          type,
          JSON.stringify(data),
          token
        );

        if (response) {
          apiResponseToast(
            response.status,
            "addWorkout",
            response.data.message
          );

          this.setState({ isLoading: false });
          if (response.type === "error") {
          } else if (response.type === "success") {
            !this.props.closeModal && closeModel(this.props.modalId);
            this.props.workoutApiCalled();

            this.resetState();
            this.props &&
              this.props.resetOnCloseModal &&
              this.props.resetOnCloseModal();

            response = "";
          }
        }
      } else {
        this.setState({ showError: true });
      }
    };

    numberToScoreType = (val) => {
      let _index = val > 5 ? val - 1 : val;
      return this.state.scoreTypeList[_index];
    };

    scoreTypeToNumber = (val) => {
      let reqScoreType;
      let _valuesAfterDeadLift = ["text", "calories", "meters"];

      val = val.toLowerCase();

      this.state.scoreTypeList.map((scoreType, index) => {
        if (scoreType.toLowerCase() === val) {
          let _inc = 0;
          _inc = _valuesAfterDeadLift.indexOf(val) !== -1 && 1;

          reqScoreType = index + _inc;
        }
      });

      return reqScoreType;
    };

    resetState = () => {
      this.props.shouldDuplicate();

      this.nameRef.current.value =
        this.props && this.props.editableWorkout
          ? this.props.editableWorkout.Name
          : null;

      this.linkRef.current.value =
        this.props && this.props.editableWorkout
          ? this.props.editableWorkout.videoUrl
          : null;

      this.descriptionRef.current.value =
        this.props && this.props.editableWorkout
          ? this.props.editableWorkout.Description
          : null;

      this.notesRef.current.value =
        this.props && this.props.editableWorkout
          ? this.props.editableWorkout.Notes
          : null;

      this.setsRef.current.value =
        this.props && this.props.editableWorkout
          ? this.props.editableWorkout.Sets
          : "1";

      this.scoreTypeRef.current.value =
        this.props && this.props.editableWorkout
          ? this.props.editableWorkout.ScoreType - 1
          : this.state.scoreTypeList[0];

      this.setState({
        showError: false,
        isLoading: false,
        scoreTypeList: [
          "For Completion",
          "Reps",
          "Round Reps",
          "Time",
          "Weight",
        ],
        data: {
          id:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Id
              : null,

          name:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Name
              : "",

          link:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.videoUrl
              : "",

          description:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Description
              : "",

          notes:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Notes
              : "",

          sets:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Sets
              : "1",

          scoreType:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.ScoreType - 1
              : 0,

          date:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.Schedule
              : this.props.workoutDate
              ? this.props.workoutDate
              : "mm/dd/yyyy",

          addToDatabase:
            this.props &&
            this.props.editableWorkout &&
            this.props.editableWorkout.WorkoutType.toLowerCase() === "database"
              ? true
              : false,

          addTotalToggle:
            this.props && this.props.editableWorkout
              ? this.props.editableWorkout.AddTotal
              : false,
        },
      });
      this.props.closeModal && this.props.closeModal();
    };

    render() {
      return (
        <div>
          <form onSubmit={this.submitHandler}>
            <div className="container mx-auto row p-0">
              <div className="col-lg-6 col-md-6 col-sm-12 p-0 pr-2">
                <div className="h5 mb-3 bold">Workout Details</div>
                <input
                  type="text"
                  className="form-control form-control-sm pl-4 inputFieldStyle"
                  placeholder="Workout Name"
                  id="workoutName"
                  maxlength="100"
                  ref={this.nameRef}
                  defaultValue={
                    this.props.editableWorkout ? this.state.data.name : ""
                  }
                  required
                  onChange={(e) =>
                    this.setState({
                      data: {
                        ...this.state.data,
                        name: e.target.value.toString(),
                      },
                    })
                  }
                />

                <input
                  url="url"
                  className="form-control form-control-sm pl-4 mt-2 quinaryColor mb-2 inputFieldStyle"
                  placeholder="Enter Youtube Link"
                  id="link"
                  ref={this.linkRef}
                  defaultValue={
                    this.props && this.props.editableWorkout
                      ? this.state.data.link
                      : ""
                  }
                  onChange={(e) =>
                    this.setState({
                      data: { ...this.state.data, link: e.target.value },
                    })
                  }
                />

                <textarea
                  className="form-control mt-2 primaryScrollBar inputFieldStyle"
                  id="workoutDetials"
                  rows="6"
                  placeholder="Workout Details"
                  ref={this.descriptionRef}
                  defaultValue={
                    this.props.editableWorkout
                      ? this.state.data.description
                      : ""
                  }
                  required
                  onChange={(e) =>
                    this.setState({
                      data: {
                        ...this.state.data,
                        description: e.target.value.toString(),
                      },
                    })
                  }
                ></textarea>
                <textarea
                  className="form-control mb-2 mt-2 primaryScrollBar inputFieldStyle"
                  id="workoutNotes"
                  rows="6"
                  placeholder="Notes"
                  ref={this.notesRef}
                  defaultValue={
                    this.props.editableWorkout ? this.state.data.notes : ""
                  }
                  onChange={(e) =>
                    this.setState({
                      data: {
                        ...this.state.data,
                        notes: e.target.value.toString(),
                      },
                    })
                  }
                ></textarea>
              </div>

              <div className="position-relative col-lg-6 col-md-6 col-sm-12 p-0">
                <div className={`h5 mb-3 bold ${style.scoring}`}>Scoring</div>

                <div className="mb-2">Score Type</div>
                <select
                  className="w-100 rounded pl-3 selectField inputFieldStyle"
                  id="scoreType"
                  ref={this.scoreTypeRef}
                  defaultValue={
                    this.props.editableWorkout &&
                    this.numberToScoreType(this.state.data.scoreType)
                  }
                  required
                  onChange={(e) =>
                    this.setState({
                      data: {
                        ...this.state.data,
                        scoreType: this.scoreTypeToNumber(e.target.value),
                      },
                    })
                  }
                >
                  {this.state.scoreTypeList.map((currVal, index, arr) => {
                    return (
                      <option key={index} option={currVal}>
                        {currVal}
                      </option>
                    );
                  })}
                </select>

                <div className="mt-2">Sets</div>

                <select
                  className="w-100 rounded pl-3 inputFieldStyle selectField mt-2"
                  id="workourSets"
                  ref={this.setsRef}
                  defaultValue={
                    this.props.editableWorkout ? this.state.data.sets : null
                  }
                  required
                  onChange={(e) =>
                    this.setState({
                      data: { ...this.state.data, sets: e.target.value },
                    })
                  }
                >
                  {[...Array(25)].map((currVal, index) => (
                    <option key={index}>{index + 1}</option>
                  ))}
                </select>

                <div className="position-relative mt-2">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Add Total"
                    disabled
                  />
                  <div
                    className={style.toggleBtn}
                    onChange={this.addTotalBtnChanger}
                  >
                    <label className="switch">
                      <input
                        type="checkbox"
                        id="addTotal"
                        checked={this.state.data.addTotalToggle}
                        onChange={(e) =>
                          this.setState({
                            data: {
                              ...this.state.data,
                              addTotalToggle: e.target.value,
                            },
                          })
                        }
                      />

                      <span className="slider round "></span>
                    </label>
                  </div>
                </div>
                <div className="position-relative mt-2">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Add To Database"
                    disabled
                  />
                  <div
                    className={`${style.toggleBtn} ${
                      this.props.editableWorkout ? "display-none" : ""
                    }`}
                    onChange={this.addToDatabaseBtnChanger}
                  >
                    <label className="switch">
                      <input
                        type="checkbox"
                        id="addToDatabase"
                        checked={this.state.data.addToDatabase}
                        onChange={(e) =>
                          this.setState({
                            data: {
                              ...this.state.data,
                              addToDatabase: e.target.value,
                            },
                          })
                        }
                      />
                      <span className="slider round "></span>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className={`d-flex justify-content-end align-items-center w-100 mt-3 mb-2`}
              >
                <button
                  className={`basicFatBtnStyle quaternaryColor colorDark mr-2`}
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.shouldDuplicate();
                    !this.props.editableWorkout && this.resetState();
                  }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="basicFatBtnStyle primaryBtn colorWhtie"
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? (
                    <div>
                      <Spinner />
                    </div>
                  ) : this.props.editableWorkout ? (
                    this.props.isDupilicate ? (
                      <span>Duplicate</span>
                    ) : (
                      <span>Update</span>
                    )
                  ) : (
                    <span>Save</span>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      );
    }
  }
);
